<form [formGroup]="interalForm">
    <p class="attestation-question" [innerHTML]="artifact.description"></p>
    <mat-radio-group formControlName="confirmation" (change)="onSelectionChange()">
        <mat-radio-button value="Yes" class="d-block mb-2">Yes</mat-radio-button>
        <mat-radio-button value="No" class="d-block mb-2">No</mat-radio-button>
    </mat-radio-group>
</form>
